import { Loader as MLoader, type LoaderProps } from "@mantine/core";
import { type CSSProperties } from "react";

import styles from "./Loader.module.scss";

interface Props extends LoaderProps {
  wrapperStyle?: CSSProperties;
}

const Loader = ({ wrapperStyle, ...loaderProps }: Props) => (
  <div className={styles.loaderBox} style={wrapperStyle}>
    <MLoader {...loaderProps} />
  </div>
);

export default Loader;
